import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";

const DropdownMenu = ({ lang, translations }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = (e) => {
    if (!e.target.closest(".menu-container")) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeMenu);
    return () => {
      document.removeEventListener("click", closeMenu);
    };
  }, []);

  return (
    <div className="menu-container" style={{ position: "relative", display: "inline-block" }}>
      {/* Botón del menú */}
      <button
        className="menu-button"
        onClick={toggleMenu}
        style={{
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          width: "40px",
          height: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Líneas de la hamburguesa */}
        <div className={`hamburger-icon ${isOpen ? "open" : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      {/* Menú desplegable */}
      {isOpen && (
        <div className="dropdown-menu">
          <ScrollLink
            to="aboutus"
            className="dropdown-options"
            onClick={() => setIsOpen(false)}
          >
            {translations[lang].gastronomytitle}
          </ScrollLink>
          <ScrollLink
            to="card"
            className="dropdown-options"
            onClick={() => setIsOpen(false)}
          >
            {translations[lang].cardtitle}
          </ScrollLink>
          <ScrollLink
            to="contact"
            className="dropdown-options"
            onClick={() => setIsOpen(false)}
          >
            {translations[lang].contacttitle}
          </ScrollLink>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
